import { useEffect, useState } from 'react';
import { useToast, Toast as ToastType } from '../contexts/ToastContext';
import { SEVERITY_TONE, DismissButton } from '../lib/severity';

const Toast = ({ toast }: { toast: ToastType }) => {
  const { hideToast } = useToast();
  const [isExiting, setIsExiting] = useState(true);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => hideToast(toast.id), 200);
  };

  useEffect(() => {
    const t = setTimeout(() => setIsExiting(false), 10);
    return () => clearTimeout(t);
  }, []);

  const tone = SEVERITY_TONE[toast.type] ?? SEVERITY_TONE.info;
  const Icon = tone.Icon;

  return (
    <div
      role={toast.type === 'error' ? 'alert' : 'status'}
      className={`
        flex items-start gap-3 rounded-xl border border-white/10 border-l-4 bg-navy shadow-lg
        py-3 pl-3 pr-2.5
        ${tone.accent}
        transition-all duration-200 ease-out
        ${isExiting ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}
      `}
    >
      <span className={`shrink-0 mt-0.5 ${tone.onDark}`}>
        <Icon className="w-5 h-5" />
      </span>
      <div className="flex-1 text-sm leading-snug text-white/90">
        {toast.message}
      </div>
      <DismissButton onClick={handleClose} dark />
    </div>
  );
};

export default Toast;
